<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content class="mat-typography">
  <h3>{{data.message}}</h3>
</mat-dialog-content>
<mat-dialog-actions class="d-flex justify-content-end">
      <button mat-raised-button mat-dialog-close>{{data.cancelText}}</button>
      <button mat-raised-button [mat-dialog-close]="true" color="primary" cdkFocusInitial>{{data.confirmText}}</button>
</mat-dialog-actions>